import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa";

import teamMemberImage from "./assets/team_member.png";

export const COMPANY_PHONE = "+255 658 902 790";
export const COMPANY_PHONE_RAW = "255658902790";
export const COMPANY_EMAIL = "msuniversaldistributor@gmail.com";
export const COMPANY_ADDRESS = "P.O. Box 20910, Dar es Salaam";
export const WHATSAPP_URL = `https://wa.me/${COMPANY_PHONE_RAW}?text=Hello%20MS%20Universal%20Distributors`;

export const navItems = [
  { label: "Home", item: "home" },
  { label: "About", item: "about_us" },
  { label: "Services", item: "services" },
  { label: "Team", item: "team" },
  { label: "Contact", item: "contact_us" },
];

export const socialLinks = [
  {
    label: "WhatsApp",
    href: WHATSAPP_URL,
    icon: FaWhatsapp,
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/",
    icon: FaFacebookF,
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/",
    icon: FaInstagram,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/",
    icon: FaLinkedinIn,
  },
];

export const teamMembers = [
  {
    name: "Ms Rustica Sanga",
    position: "Founder",
    image: teamMemberImage,
  },
  {
    name: "Mr Paul Sanga",
    position: "General Manager",
    image: teamMemberImage,
  },
  {
    name: "Ms Neema Daniel",
    position: "Procurement Officer",
    image: teamMemberImage,
  },
  {
    name: "Ms Amina Joseph",
    position: "Business Administrator",
    image: teamMemberImage,
  },
  {
    name: "Mr Kelvin Mushi",
    position: "Accounts Officer",
    image: teamMemberImage,
  },
  {
    name: "Ms Rehema Mwakalinga",
    position: "Human Resources Support",
    image: teamMemberImage,
  },
];
